<template>
  <el-menu :default-active='this.$route.path' :router='true' :collapse="isCollapse" class="el-menu-vertical-demo">
    <div class="topSide">
      <img src="../../assets/logo.png" class="logout" alt="">
    </div>
    <div v-for="(item ,index) in data" :key="index">
      <el-submenu v-if="item.children" :index='item.path' >
        <template slot='title'>
          <i :class="item.icon"></i>
          <span :title="item.name">{{item.name}}</span>
        </template>
        <div v-for="(it,index) in item.children" :key="index">
          <el-menu-item :index='it.path'>
            <span :title="it.name">{{it.name}}</span>
          </el-menu-item>
        </div>
      </el-submenu>
      <el-menu-item v-else :index='item.path'>
        <i :class="item.icon"></i>
        <span :title="item.name">{{item.name}}</span>
      </el-menu-item>
    </div>
  </el-menu>
</template>

<script>
export default {
  data() {
    return {
      isCollapse: false,
      data: [
        {
          name: '管理',
          icon: 'el-icon-message',
          path:'/cabinets',
          children: [
            {
              name: '机柜管理',
              path: '/cabinets',
            },
            {
              name: 'APP管理',
              path: '/apps',
            },
            {
              name: '管理员管理',
              path: '/users',
            },
            {
              name: '版本管理',
              path: '/versions',
            }
          ]
        },
        {
          name: '选项2',
          path: 'other',
          icon: 'el-icon-menu'
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.topSide {
  height: 66px;
  border-bottom: 1px solid #dadada;
  background: #363636;
  color: #fff;
  .logout {
    width: 139px;
    height: 30px;
    margin: 18px 0 0 20px;
  }
}
</style>














// WEBPACK FOOTER //
// src/views/layout/Sidebar.vue?01e6bb8f